import { render, staticRenderFns } from "./CampaignParticipants.vue?vue&type=template&id=f485ae94&"
import script from "./CampaignParticipants.vue?vue&type=script&lang=js&"
export * from "./CampaignParticipants.vue?vue&type=script&lang=js&"
import style0 from "./CampaignParticipants.vue?vue&type=style&index=0&id=f485ae94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports